<div
  class="gallery-container"
  [style.--gallery-background-color]="theme().layout_page.background_color || 'white'"
  [class.dark-background]="theme().layout_page.background_color | isDarkColor"
  [class.no-bottom-padding]="noBottomPadding()"
>
  <app-gallery-cover
    #galleryCover
    [gallery]="gallery()"
    [theme]="theme()"
    [galleryPermissions]="galleryPermissions()"
    [titleAndDescription]="gallery().title + gallery().description"
    [darkBackground]="theme().layout_page.background_color | isDarkColor"
  >
  </app-gallery-cover>
  @if (sections()?.length) {
    <div class="gallery-bottom">
      @for (section of sections() | sortBy: 'position'; track section.id; let i = $index) {
        <div class="section" [id]="'section-' + section.id" appFlipItem [id]="section.id" [position]="$index">
          @if (section.object === 'asset') {
            @if (growthBook.isOn('new-assets-section')) {
              <!-- <app-new-assets-section
                [section]="section"
                [sectionIndex]="i"
                [gallery]="gallery()"
                [theme]="theme()"
                [sections]="sections()"
                [allowFeedback]="allowFeedback()"
                [galleryPermissions]="galleryPermissions()"
                [darkBackground]="section.layout_background_color || theme().layout_page.background_color | isDarkColor"
                [allowedAndEnabledFeedbackOptions]="allowedAndEnabledFeedbackOptions()"
                [approvedAssetCount]="approvedAssetCount()"
                (addSection)="openAddSection(section.position + $event)"
              >
              </app-new-assets-section> -->
            } @else {
              <app-assets-section
                [section]="section"
                [sectionIndex]="i"
                (onCoverChange)="onCoverChange()"
                [gallery]="gallery()"
                [theme]="theme()"
                (onMove)="onMove(section.id, $event)"
                (onDrop)="onDrop($event)"
                [sections]="sections()"
                [galleryPermissions]="galleryPermissions()"
                [darkBackground]="section.layout_background_color || theme().layout_page.background_color | isDarkColor"
                [allowedAndEnabledFeedbackOptions]="allowedAndEnabledFeedbackOptions()"
                [approvedAssetCount]="approvedAssetCount()"
                [filters]="filters"
                (addSection)="openAddSection(section.position + $event)"
              >
              </app-assets-section>
            }
          }
          @if (!filters?.length) {
            @if (section.object === 'text') {
              <app-edit-text-section
                [gallery]="gallery()"
                [theme]="theme()"
                [sectionIndex]="i"
                [section]="section"
                [sections]="sections()"
                [galleryPermissions]="galleryPermissions()"
                [darkBackground]="section.layout_background_color || theme().layout_page.background_color | isDarkColor"
                (addSection)="openAddSection(section.position + $event)"
              >
              </app-edit-text-section>
            }
            @if (section.object === 'gallery') {
              <app-edit-album-section
                [section]="section"
                [theme]="theme()"
                [sectionIndex]="i"
                (onMove)="onSubGalleryMove($event)"
                (onMoveStart)="onSubGalleryMoveStart($event)"
                (onMoveDrop)="onSubGalleryMoveDrop($event)"
                [parentGallery]="gallery()"
                [sections]="sections()"
                [galleryPermissions]="galleryPermissions()"
                [darkBackground]="section.layout_background_color || theme().layout_page.background_color | isDarkColor"
                (addSection)="openAddSection(section.position + $event)"
              >
              </app-edit-album-section>
            }
            @if (section.object === 'embed') {
              <app-edit-embed-section
                [gallery]="gallery()"
                [theme]="theme()"
                [sectionIndex]="i"
                [section]="section"
                [darkBackground]="section.layout_background_color || theme().layout_page.background_color | isDarkColor"
                [sections]="sections()"
                [galleryPermissions]="galleryPermissions()"
                (addSection)="openAddSection(section.position + $event)"
              >
              </app-edit-embed-section>
            }
          }
        </div>
      }
    </div>
  }

  <ng-content></ng-content>
</div>

@if (aiService.showAiUi$ | async; as data) {
  <app-image-generator-prompt [sectionId]="data.section"></app-image-generator-prompt>
}
